import { invoiceConstant } from '../constants/invoice.constant';
import { Invoice } from '../../services/invoice.service';

const fetchInvoiceGroupHeaderSuccess = response => ({
    type: invoiceConstant.GET_INVOICE_LOOKUP_SUCCESS,
    payload: response,
});

const fetchInvoiceGroupHeaderFailed = () => ({
    type: invoiceConstant.GET_INVOICE_LOOKUP_FAILED,
});

const fetchInvoiceGroupHeaderPending = () => ({
    type: invoiceConstant.GET_INVOICE_LOOKUP_PENDING,
});

export const fetchInvoiceGroupHeader = data => {
    return dispatch => {
        dispatch(fetchInvoiceGroupHeaderPending());
        Invoice.getInvoiceGroupHeaderService(data)
            .then(result => {
                dispatch(
                    fetchInvoiceGroupHeaderSuccess({
                        entityList: result.data.EntityList,
                        totalRecords: result.data.TotalRecords,
                    })
                );
            })
            .catch(error => {
                dispatch(fetchInvoiceGroupHeaderFailed());
            });
    };
};
